import ActivityExplain from './ActivityExplain';
import TopProduct from './TopProduct';
import ProductItem from './ProductItem';

export default function TabC() {
    return (
        <>
            <ActivityExplain />
            <TopProduct />
            <ProductItem />
        </>
    );
}
